import React, {Component} from 'react';
import api from '../../services/api';
import {Container} from './styles';
import {FiEye, FiEyeOff} from 'react-icons/fi';
import {Spinner} from 'react-activity';
import 'react-activity/dist/react-activity.css';
import { Link, Redirect } from 'react-router-dom';

import Cadeado from '../../assets/emojis/cadeado/cadeado.png'


export default class TrocarSenha extends Component {

    constructor(props) {
        super(props);
        this.state = {
            senha1: '',
            senha2: '',
            senha3: '',
            jwt: '',
            verify: true,
            carregando: false,
            senha1Class: 'div-input',
            senha2Class: 'div-input',
            senha3Class: 'div-input',
            type: 'password',
            confirmed: false,
            redirect: false
        }
    }

    async mudarSenha(carregando) {
        const params = {
            nova: this.state.senha2,
            atual: this.state.senha1
        }
        const token = await localStorage.getItem('@jwt');
        try {
            this.setState({
                carregando: true
            });
            await api.put('/api/restauranteconfigs/nps', params, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(res => {
                if (res.data) {
                    this.setState({
                        carregando: false,
                        confirmed: true
                    })
                } else {
                    this.setState({
                        carregando: false,
                        senha1Class: 'div-input-error'
                    })
                }
            }).catch(async e => {
                if (e.response.status === 401) {
                    try {
                        await localStorage.removeItem('@username');
                                await localStorage.removeItem('@jwt');
                                await localStorage.removeItem('@user');
                                await localStorage.removeItem('@rest');
                                await localStorage.removeItem('@uf');
                                await localStorage.removeItem('@internal');
                                await localStorage.removeItem('@suser');
                        this.setState({
                            redirect: true
                        })
                    } catch (e) {
                        console.log(e.data);
                    }
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    handleEye() {
        const {type} = this.state;
        if (type !== 'text') {
            this.setState({
                type: 'text'
            })
        } else {
            this.setState({
                type: 'password'
            })
        }
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'senha1':
                this.setState({
                    senha1: event.target.value
                });
                break;
            case 'senha2':
                this.setState({
                    senha2: event.target.value
                });
                break;
            case 'senha3':
                this.setState({
                    senha3: event.target.value
                });
                break;
            default:
                break;
        }
    }

    render(){
        if (this.state.redirect) {
            return <Redirect push to="/login" />
        }
        return(
            <Container>
                 
                <div className="div-rota">

                    <Link 
                        style={{ textDecoration: 'none' }}
                        to={'/'}>
                        <span
                            className="rotas" >
                            Início
                        </span>
                    </Link>

                    <span className="rotas"> {'>'} </span>

                    <Link 
                        style={{ textDecoration: 'none' }}
                        to={'/novaSenha'}>
                        <span>
                            Trocar Senha
                        </span>
                    </Link>

                </div>

                <div className="titulo">

                    <img alt="" className="emoji" src={Cadeado} />

                    <h1>Trocar Senha</h1>

                </div>  

                <div className='novasenha-container'>
                    {
                        this.state.verify === null ?
                        null
                        : this.state.verify === false ?
                        <>
                        {/* <img 
                            src={logo}
                            className="logocompletovermelho" /> */
                        }
                        <div className="div-bem-vindo">
                                    <span
                                    className="sejabemvindo"
                                    >Esse link não está mais disponível.</span>
                            </div>
                            <div className="div-botao">
                                <button
                                onClick={() => this.setState({redirect: true})}
                                className="botaologin-active"
                                >Voltar para o Painel do Restaurante</button>
                            </div>
                        </>
                        : this.state.verify === true ?
                        <>
                            {/* <img 
                            src={logo}
                            className="logocompletovermelho" /> */}

                            <div className="div-bem-vindo">
                                <span className="sejabemvindo">
                                    {
                                        this.state.confirmed ? 
                                        'Sua senha foi alterada com sucesso!' : 'Crie sua nova senha nos campos abaixo'
                                    }
                                </span>
                            </div>

                            <div className='gray-line'>

                            </div>
                        {
                            this.state.confirmed ?
                            null
                            :
                            <>
                            <div className={this.state.senha1Class}>
                                <input 
                                    value={this.state.senha1}
                                    onFocus={() => {
                                        this.setState({
                                            senha1Class: 'div-input-focado'
                                        })
                                    }}
                                    onBlur={() => {
                                        this.setState({
                                            senha1Class: 'div-input'
                                        })
                                    }}
                                    onChange={event => this.handleInputs(event)}
                                    name="senha1"
                                    type="password"
                                    required
                                    />
                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Digite sua senha atual</span>
                                    </label>
                        </div>

                        {this.state.senha1Class === 'div-input-error' ? 
                        <div className="div-invalido">
                            <span
                            className='texto-invalido'
                            >Senha incorreta</span>
                        </div>    
                        : null}

                        <div className={this.state.senha2Class}>
                                <input 
                                    value={this.state.senha2}
                                    onFocus={() => {
                                        this.setState({
                                            senha2Class: 'div-input-focado'
                                        })
                                    }}
                                    onBlur={() => {
                                        this.setState({
                                            senha2Class: 'div-input'
                                        })
                                    }}
                                    onChange={event => this.handleInputs(event)}
                                    name="senha2"
                                    type={this.state.type}
                                    required
                                    />
                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Digite sua nova senha</span>
                                    </label>
                                    <button
                                        className="botao-olho"
                                        onClick={() => this.handleEye()}
                                        >
                                        {
                                            this.state.type === 'password'
                                            ?
                                            <FiEyeOff color="#1c0506" className="i" />
                                            :
                                            <FiEye color="#1c0506" className="i" />
                                        }
                                    </button>
                        </div>

                        <div className={this.state.senha3Class}>
                                <input 
                                    value={this.state.senha3}
                                    onFocus={() => {
                                        this.setState({
                                            senha3Class: 'div-input-focado'
                                        })
                                    }}
                                    onBlur={() => {
                                        this.setState({
                                            senha3Class: 'div-input'
                                        })
                                    }}
                                    onChange={event => this.handleInputs(event)}
                                    name="senha3"
                                    type={'password'}
                                    required
                                    />
                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Confirme sua nova senha</span>
                                    </label>
                                    {/* <button
                                        className="botao-olho"
                                        onClick={() => this.handleEye()}
                                        >
                                        {
                                            this.state.type === 'password'
                                            ?
                                            <FiEyeOff color="#1c0506" className="i" />
                                            :
                                            <FiEye color="#1c0506" className="i" />
                                        }
                                    </button> */}
                        </div>
                            </>
                        }
                        <div className="div-botao">
                        <button
                            onClick={() => (this.state.senha1 && this.state.senha2 !== '') && this.state.senha1Class !== 'div-input-error' && this.state.confirmed === false && this.state.senha2 === this.state.senha3
                                ? this.mudarSenha(this.state.carregando)
                                : this.state.confirmed === true ? this.setState({redirect: true}) : null}
                            className={(this.state.senha1 && this.state.senha2 !== '') && this.state.senha1Class !== 'div-input-error' && this.state.senha2 === this.state.senha3
                                ? 'botaologin-active'
                                : 'botaologin'}
                            >{this.state.carregando ? <Spinner
                                className='spinner'
                                color="#fff" size={11} speed={1} animating={true} />
                            : this.state.confirmed ? 'Voltar para o Inicio' : 'Salvar alterações'}</button>
                        </div>
                        </>
                        : null
                    }
            </div>
            </Container>
        )
    }

}